// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__YSaGR","logo":"MainLayout_logo__vN9Ta","sidebar":"MainLayout_sidebar__jcbKu","menu":"MainLayout_menu__bAemP","content":"MainLayout_content__Aw8tk"};